import PageTop from '@/components/PageTop';
import { LayoutProps } from '.';
import StickyProgramAndSignup from '@/components/StickyProgramAndSignup';

export const SectionFrontPageLayout = ({ children, properties, image }: LayoutProps) => {
  return (
    <>
      <PageTop image={image} properties={properties} />
      <StickyProgramAndSignup
        isActive={properties?.isActive}
        program={properties?.programLink?.[0] as Record<string, any>}
        signup={properties?.signUpLink?.[0] as Record<string, any>}
      />

      <section>{children}</section>
    </>
  );
};

export default SectionFrontPageLayout;
